<template>
  <validation-observer tag="div" ref="form">
    <validation-provider vid="type" :name="lodash.upperFirst($t('vehicles.vehicle_type'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('vehicles.vehicle_type')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-select
            id="type"
            name="type"
            :placeholder="lodash.startCase($t('vehicle.vehicle_type'))"
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.type"
            :options="type_options"
        />
      </b-form-group>
    </validation-provider>
    <validation-provider vid="license_plate" :name="lodash.upperFirst($t('vehicles.license_plate'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('vehicles.license_plate'))"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-input
            name="license_plate"
            type="text"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.license_plate"
            :formatter="value => value.toUpperCase()"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <hr>
    <validation-provider vid="description" :name="lodash.upperFirst($t('models.description'))" rules="" v-slot="{ validated, errors }">
      <b-form-group
        class="row mb-3"
        :label="lodash.upperFirst($t('models.description'))"
        :state="errors[0] ? false : (validated ? true : null)"
        :invalid-feedback="errors[0]"
      >
        <editor
          ref="editor"
          v-if="$parent.$parent.$options.name !== 'BModal'"
          class="form-control"
          :init="editorInit"
          inline
          plugins="lists link image paste help wordcount"
          toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
          v-model="model.description"
        />
        <b-form-textarea v-else v-model="model.description" />
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
  import FormModel from './model';

  export default {
    extends: FormModel,
    data() {
      return {
        type_options: [
          { value: null, text: this.$t('Select {something}', { something: this.$t('vehicles.vehicle_type')}) },
          { value: 'light', text: this.lodash.upperFirst(this.$t('vehicles.pickup')) },
          { value: 'medium', text: this.lodash.upperFirst(this.$t('vehicles.crank_truck')) },
          { value: 'heavy', text: this.lodash.upperFirst(this.$t('vehicles.truck')) }
        ],
        model: {
          type: null,
          ...this.value,
        }
      }
    },
    watch: {
      'model.type': function (val, oldVal) {
        if (val !== oldVal) {
          this.model.box_capacity = this.getBoxCapacityByType(val)
          this.model.name = this.getNameByType(val)
        }
      }
    },
    mounted() {
      //
    },
    methods: {
      getNameByType(type) {
        let name = null

        if (type === 'light') name = 'pickup'
        else if (type === 'medium') name = 'crank_truck'
        else if (type === 'heavy') name = 'truck'

        return name
      },
      getBoxCapacityByType(type) {
        let capacity = null

        if (type === 'light') capacity = 8
        else if (type === 'medium') capacity = 16
        else if (type === 'heavy') capacity = 42

        return capacity
      }
    }
  }
</script>
